import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconEndAdornment } from 'components/Button';
import { Heading } from 'components/Typography';
import { LearningPathCtx, withLearningPathContext } from 'domains/learning-path/context';
import { LearningPathStepID } from 'domains/learning-path/steps';
import { MarkdownText } from 'domains/contentful/MarkdownText';

const HelpfulTipsContent: React.FC = () => {
  const { t } = useTranslation();

  const {
    learningPath: {
      helpfulTipsSection: {
        fields: { tips },
      },
    },
    onNavigateToStep,
  } = useContext(LearningPathCtx);

  const handleClick = () => onNavigateToStep(LearningPathStepID.knowledgeCheck, true);

  return (
    <>
      <Heading level="h3" useDefaultMargins>
        {t('learningPath.helpfulTips')}
      </Heading>

      {tips.map(({ fields: { answer, question }, sys: { id } }) => (
        <div className="mb-40" key={id}>
          <Heading level="h5" className="mb-8 font-semibold">
            {question}
          </Heading>
          <MarkdownText>{answer}</MarkdownText>
        </div>
      ))}

      <Button
        size="lg"
        onClick={handleClick}
        endAdornment={<IconEndAdornment name="AngleRight" />}
        className="sm-d:w-full"
      >
        {t('learningPath.continueButton')}
      </Button>
    </>
  );
};

export default withLearningPathContext(HelpfulTipsContent, LearningPathStepID.helpfulTips);
